import React from 'react';

import './MediaPageNavSkeleton.scss';

const MediaPageNavSkeleton = () => (
  <div className="filterBtn media-nav-skeleton">
    <div className="media-nav-skeleton__item" />
    <div className="media-nav-skeleton__item" />
    <div className="media-nav-skeleton__item" />
  </div>
);

export default MediaPageNavSkeleton;

